import {
    compareOutsidersRows,
    getLastThreeMeta,
    lexCompareOutsiders,
} from "./lastThreeUtils";
import { oddsWeightedTotalForPerson } from "./oddsUtils";

/** Match displayed totals on Main tab (floored dollars). */
export function mainSectionLeaderNames(rankings) {
    if (!rankings?.length) return [];
    const best = Math.max(
        ...rankings.map((p) => Math.floor(p.totalMoney)),
    );
    return rankings
        .filter((p) => Math.floor(p.totalMoney) === best)
        .map((p) => p.name)
        .sort((a, b) => a.localeCompare(b));
}

/** Match displayed totals on Odds tab (floored). */
export function oddsSectionLeaderNames(rankings, entryByName) {
    if (!rankings?.length) return [];
    const floorScore = (p) =>
        Math.floor(oddsWeightedTotalForPerson(p, entryByName));
    const best = Math.max(...rankings.map(floorScore));
    return rankings
        .filter((p) => floorScore(p) === best)
        .map((p) => p.name)
        .sort((a, b) => a.localeCompare(b));
}

/** Co-leaders share the same Outsiders sorted-desc prize multiset. */
export function outsidersSectionLeaderNames(rankings) {
    if (!rankings?.length) return [];
    const rows = rankings.map((person) => ({
        person,
        ...getLastThreeMeta(person),
    }));
    rows.sort(compareOutsidersRows);
    const top = rows[0];
    const keyTop = top.sortedAmountsDesc;
    return rows
        .filter((r) => lexCompareOutsiders(r.sortedAmountsDesc, keyTop) === 0)
        .map((r) => r.person.name)
        .sort((a, b) => a.localeCompare(b));
}
